var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backChart"},[_c('div',{staticClass:"backChart_back",style:({
        background:("url('" + (_vm.configImgUrl()) + (_vm.backGroundList[_vm.back.index].img) + "')"),
        })}),_c('div',{staticClass:"backChart_modal",style:({
        backgroundColor:_vm.back.modalBackColor,
        })})])}
var staticRenderFns = []

export { render, staticRenderFns }